import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/xebia.webp';
import screenshot_target from '../../../images/letterfunnel/jorisconijn.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Joris Conijn"
      firstname="Joris"
      companyname="Xebia"
      competition="Thoughtworks en Capgemini"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jorisconijn.js